import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../../../boot";
import axios from "axios";

// get orders

export const getTags = createAsyncThunk("client/get-tag-list", async (data) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(`${baseUrl}vancouverapis/admin/tag/api/v1/get-tag-master-list`, data, {
      headers: {
        "auth-token": token,
      },
    });
    console.log("this is response of tags list", response);
    return response;
  } catch (error) {
    console.error("Error fetching tags - ", error);
    throw error;
  }
});

// get count of tags

export const getTagCount = createAsyncThunk("client/get-tag-count", async () => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.get(`${baseUrl}vancouverapis/admin/tag/api/v1/get-tag-count`, {
      headers: {
        "auth-token": token,
      },
    });
    console.log("this is response of tags count", response);
    return response;
  } catch (error) {
    console.error("Error fetching tags count - ", error);
    throw error;
  }
});
